/* eslint-disable */

// NB! This file is auto-generated, do not change it manually.
// In order to update it, run `make gen-client` in the backend repository.

import { buildApi } from './utils';

const Api = buildApi({
  $company: {
    events: {
      register: {
        $clientId: 'GET'
      },
      test: 'GET'
    }
  },
  ai: {
    _: 'CRUD',
    generateChecklist: 'POST',
    improveText: 'POST'
  },
  auth: {
    refreshUser: 'GET'
  },
  authentication: {
    _: 'CRUD',
    mobile: {
      login: 'POST',
      logout: 'POST',
      resendCode: 'POST',
      verifyCode: 'POST',
      veryfiCode: 'POST'
    },
    web: {
      confirm_password: 'POST',
      login: 'POST',
      oauth2enabled: 'GET',
      resend_code: 'POST',
      reset_password: {
        $resetLinkId: 'GET',
        _: 'POST'
      },
      verify: 'POST'
    }
  },
  calendarImport: {
    redirect: {
      google: 'GET',
      outlook: 'GET',
      slack: 'GET'
    },
    slackCallback: 'POST'
  },
  companies: {
    $company: {
      _: 'CRUD',
      absenceAdjustmentAmount: {
        _: 'CRUD',
        functions: {
          updateAmount: 'POST'
        }
      },
      absenceAdjustments: 'CRUD',
      absenceRules: {
        _: 'CRUD',
        applyAbsenceRules: 'POST'
      },
      absenceTypes: 'CRUD',
      absences: {
        _: 'CRUD',
        batchAddAbsences: 'POST',
        exportToFile: 'GET',
        functions: {
          convertProjectToAbsence: 'POST',
          convertProjectToAbsenceByIds: 'POST',
          convertProjectToAbsenceByProjectNumber: 'POST',
          transferAndSetInitialAbsenceAdjustments: 'POST'
        },
        generate: {
          $filename__pdf: 'POST',
          $filename__xlsx: 'POST'
        },
        generateExcelTemplate: 'GET',
        getReportWithPaging: 'GET',
        overview: 'GET',
        plannedAbsences: 'GET',
        plannedAbsencesForProjectOwner: 'GET',
        statisticsForUser: 'GET',
        updateFromExcel: 'POST'
      },
      accessRoles: {
        _: 'CRUD',
        functions: {
          activateAccessRoles: 'POST',
          activateAccessRolesOneToOne: 'POST'
        },
        permissions: {
          $permissionScope: 'GET'
        }
      },
      accountingDepartments: 'CRUD',
      accountingProjects: 'CRUD',
      actualServiceMessageCount: 'GET',
      additionalCustomer: 'CRUD',
      addresses: {
        _: 'CRUD',
        functions: {
          updateCoordinates: {
            _: 'POST',
            batch: 'POST'
          }
        }
      },
      adminCustomers: 'CRUD',
      adminTools: {
        _: 'CRUD',
        customers: 'GET',
        projects: 'GET',
        system: {
          _: 'CRUD',
          recovery: {
            createRecoveryAccess: 'POST',
            permitSupportAccess: 'POST',
            revokeRecoveryAccess: 'POST'
          },
          roles: 'POST'
        }
      },
      ambita: {
        _: 'CRUD',
        getOrganizationToken: 'GET',
        getToken: 'GET'
      },
      analytics: {
        _: 'CRUD',
        absences: 'GET',
        budgetMonthly: 'GET',
        company: 'GET',
        enable: 'POST',
        expenses: 'GET',
        fixedPriceEstimation: 'GET',
        invoiceLineProductSales: 'GET',
        invoiceLines: 'GET',
        invoiceLinesByUser: 'GET',
        invoices: 'GET',
        nonconformities: 'GET',
        pages: 'GET',
        productSales: 'GET',
        projects: 'GET',
        resourceReservations: 'GET',
        schedulesPerDay: 'GET',
        subscriptionLines: 'GET',
        tasks: 'GET',
        timeRecords: 'GET',
        toBeInvoiced: 'GET',
        translations: 'GET',
        userAccounts: 'GET'
      },
      asyncJob: {
        _: 'CRUD',
        cancel: 'POST',
        existing: 'GET',
        start: 'POST'
      },
      authenticationTokenUserAccounts: {
        _: 'CRUD',
        functions: {
          deleteKey: {
            $id: 'DELETE'
          },
          generateKey: 'POST',
          updateExpiryDate: 'PUT'
        }
      },
      billabilityRateGoals: 'CRUD',
      budgets: {
        _: 'CRUD',
        templateExcel: 'GET'
      },
      calendarImport: {
        deleteIntegration: 'POST',
        get: 'GET'
      },
      calendarImportTimeRecords: {
        _: 'CRUD',
        functions: {
          calendarImportBatchDeleteEvents: 'POST',
          calenderImportBatchCreateTimeRecords: 'POST',
          createTimeRecords: 'PUT',
          suggestProjects: 'POST'
        }
      },
      checkLicensesCount: 'GET',
      checklistItems: {
        _: 'CRUD',
        functions: {
          generateChecklistItem: 'POST'
        }
      },
      checklists: {
        $checklistId: {
          assignTo: {
            tasks: 'POST'
          },
          convertToTemplate: {
            _: 'POST',
            include: {
              $includes: 'POST'
            }
          },
          copy: {
            _: 'POST',
            include: {
              $includes: 'POST'
            }
          },
          delete: 'DELETE',
          pdf: 'GET'
        },
        _: 'CRUD',
        copy: {
          $checklistId: {
            $projectId: 'GET'
          }
        },
        findPublicTemplates: 'GET',
        functions: {
          batchChecklist: 'POST',
          copyToProject: 'POST'
        },
        generate: {
          $filename__pdf: 'POST',
          $filename__xlsx: 'POST'
        },
        getReportWithPaging: 'GET',
        nextChecklistNumber: 'GET',
        sharedChecklistTemplates: 'GET'
      },
      claim: 'CRUD',
      claimEntries: {
        _: 'CRUD',
        exportToFile: 'GET',
        generate: {
          $filename__pdf: 'POST',
          $filename__xlsx: 'POST'
        },
        generateExcelTemplate: 'GET',
        getReportWithPaging: 'GET',
        report: 'GET',
        updateFromExcel: 'POST'
      },
      claims: {
        $claimId: {
          _: 'DELETE,GET,PUT',
          approve: 'POST',
          entries: {
            $claimEntryId: {
              _: 'DELETE,GET,PUT',
              cloudFiles: {
                $cloudFileId: 'DELETE',
                _: 'POST'
              }
            },
            _: 'POST'
          },
          html: 'GET',
          include: {
            $includes: 'GET'
          },
          pdf: 'GET',
          refreshPdf: 'POST',
          refund: 'POST',
          reject: 'POST',
          undoRefund: 'POST'
        },
        _: 'CRUD',
        generate: {
          $filename__pdf: 'POST',
          $filename__xlsx: 'POST'
        },
        getReportWithPaging: 'GET',
        moveAttachmentToInbox: {
          $cloudFileId: 'POST'
        },
        report: 'GET',
        suggestions: 'GET'
      },
      companyPartnerships: {
        _: 'CRUD',
        include: {
          base: 'GET'
        }
      },
      companySchedules: 'CRUD',
      companyStrings: {
        _: 'CRUD',
        ownedStrings__js: 'GET'
      },
      compensationTypes: 'CRUD',
      contactInCustomers: {
        _: 'CRUD',
        functions: {
          assignByCustomerIdAndContactId: 'POST',
          removeByCustomerIdAndContactId: 'DELETE'
        }
      },
      contactInProjects: {
        _: 'CRUD',
        functions: {
          assignByProjectIdAndContactId: 'POST',
          removeByProjectIdAndContactId: 'DELETE'
        }
      },
      contacts: {
        _: 'CRUD',
        generate: {
          $filename__pdf: 'POST',
          $filename__xlsx: 'POST'
        },
        getReportWithPaging: 'GET',
        invoiceEmailRecipients: 'GET',
        mergeContacts: 'POST',
        report: 'GET',
        similar: 'GET'
      },
      currencies: {
        _: 'CRUD',
        search: {
          findDistinctCurrencyCodes: 'GET'
        }
      },
      customFields: 'CRUD',
      customFieldsInCustomers: 'CRUD',
      customFieldsInProjectExtension: 'CRUD',
      customFieldsInProjects: 'CRUD',
      customFieldsInTasks: 'CRUD',
      customFieldsInUserAccounts: 'CRUD',
      customerHourlyRateGroups: 'CRUD',
      customerInvoiceEmailSubscriptions: 'CRUD',
      customers: {
        $id: {
          linkedCustomers: 'GET',
          metadata: 'GET',
          moveDataToOtherCustomerAndDelete: 'POST'
        },
        _: 'CRUD',
        changeCustomerNumbersToNewRangeByFilter: 'POST',
        editTransferState: 'POST',
        exportToFile: 'GET',
        functions: {
          cloneCustomer: 'POST'
        },
        generate: {
          $filename__pdf: 'POST',
          $filename__xlsx: 'POST'
        },
        generateCustomerAddressLabelsPdf: 'GET',
        generateExcelTemplate: 'GET',
        getReportWithPaging: 'GET',
        nextCustomerNumber: 'GET',
        reports: {
          customerBalance: 'GET',
          customerBalanceAsExcel: 'GET',
          customerBalanceAsPdf: 'GET'
        },
        search: {
          findByNameFuzzy: 'GET',
          findByNameStartingWith: 'GET',
          findSimpleByExactCountryCodeAndOrganizationNumber: 'GET',
          findSimpleByExactCustomerNumber: 'GET',
          findSimpleByNameStartingWith: 'GET'
        },
        setCreatedDateToNow: 'POST',
        setCustomersNumberLength: 'POST',
        setInactiveByFilter: 'POST',
        updateFromExcel: 'POST'
      },
      dayOptions: 'CRUD',
      departments: {
        $id: {
          moveDataToOtherDepartmentAndDelete: 'POST'
        },
        _: 'CRUD'
      },
      employeesEducationAdjustments: {
        _: 'CRUD',
        transferAndSetInitialEducationDeductibleAdjustments: 'POST'
      },
      employeesEducationCommonPool: 'CRUD',
      employeesEducationExpenses: 'CRUD',
      employeesEducationPersonalPool: 'CRUD',
      employeesEducationPoolDeductibles: {
        _: 'CRUD',
        statisticsForUser: 'GET',
        statisticsForUsers: 'GET'
      },
      employeesEducationRule: {
        _: 'CRUD',
        applyEmployeesEducationRules: 'POST',
        userAccountHasEducationRuleTag: 'GET'
      },
      enabledLocaleCodes: 'CRUD',
      entityChangeLogs: 'CRUD',
      enums: {
        $name: 'GET',
        _: 'CRUD'
      },
      errors: {
        _: 'CRUD',
        clientError: 'POST',
        logClientError: 'POST'
      },
      expenseCategories: 'CRUD',
      expenseTemplates: 'CRUD',
      expenses: {
        _: 'CRUD',
        generate: {
          $filename__pdf: 'POST',
          $filename__xlsx: 'POST'
        },
        getReportWithPaging: 'GET',
        importFromSocialMediaFile: {
          $cloudFileId: 'POST'
        }
      },
      export: {
        _: 'CRUD',
        accountingSystem: {
          _: 'CRUD',
          multi: 'GET,POST'
        },
        customers: 'POST',
        expenses: 'POST',
        getClaimPaidOutDates: 'GET',
        invoices: 'POST',
        projects: 'POST',
        resetPaidOutClaims: 'POST'
      },
      exportTemplates: {
        $exportTemplateId: {
          functions: {
            copy: 'POST'
          }
        },
        _: 'CRUD',
        findAll: 'GET',
        getPreprocessorFields: 'GET',
        getPreprocessors: 'GET',
        test: 'POST'
      },
      externalObjectLink: 'CRUD',
      featureFlags: {
        _: 'CRUD',
        functions: {
          clearCompanyOverride: 'POST',
          clearOverrides: 'POST',
          clearUserOverride: 'POST'
        }
      },
      feedback: {
        _: 'CRUD',
        sunset: 'POST'
      },
      fileTransfer: {
        _: 'CRUD',
        activateCustomers: 'POST',
        activateCustomersInit: 'POST',
        createDocumentLibraryIfNotExists: 'POST',
        isSharePointCustomerNameUnique: 'GET',
        session: 'GET,POST',
        transferCustomerFiles: 'POST',
        transferProjectFiles: 'POST',
        updateSharePointFilesMetadata: 'POST'
      },
      files: {
        $id: {
          content: {
            $version: 'GET',
            _: 'GET'
          },
          contentRedirect: {
            $version: 'GET',
            _: 'GET'
          }
        },
        _: 'CRUD',
        createPreviews: 'POST',
        downloadAsZip: 'GET',
        functions: {
          fetchEmailFilter: 'GET',
          fetchUploadedByFilter: 'GET',
          hasChecklists: 'GET',
          hasTags: 'GET',
          uploadFileToSharePoint: 'POST'
        },
        uploadPermission: 'GET'
      },
      filterSettings: 'CRUD',
      financialAccountMaps: 'CRUD',
      financialAccounts: 'CRUD',
      functions: {
        acceptDataProcessingAgreement: 'POST',
        addCompaniesToGroup: 'POST',
        assignAccountAdministrators: 'POST',
        batchDeleteEntities: 'POST',
        changeMomentPlan: 'POST',
        changeMomentPlanAdmin: 'POST',
        createApiKey: 'GET,POST',
        isNumberOfLicensesMoreThanEnabledResources: 'GET',
        moveSystemUserToAnotherCompany: 'POST',
        setAllowIntegrationSandbox: 'POST',
        updateAmountInClaims: 'POST'
      },
      global: {
        newsEntries: {
          _: 'CRUD',
          unseenId: 'GET'
        },
        serviceMessages: 'CRUD'
      },
      groupHourlyRates: 'CRUD',
      hierarchy: 'GET',
      holidays: {
        _: 'CRUD',
        search: {
          findByDate: 'GET'
        }
      },
      holte: {
        _: 'CRUD',
        project: {
          $holteProjectId: 'PUT',
          $projectNumber: 'GET',
          _: 'POST'
        }
      },
      hourlyRateGroups: {
        _: 'CRUD',
        exportToFile: 'GET',
        generateExcelTemplate: 'GET',
        getUpdateGroupHourlyRatesTemplateExcel: 'GET',
        updateFromExcel: 'POST',
        updateGroupHourlyRatesFromExcel: 'POST'
      },
      import: {
        _: 'CRUD',
        brregImport: 'POST',
        expenses: {
          _: 'POST',
          socialMedia: 'POST'
        },
        importFile: 'POST',
        importProjectHelp: 'POST'
      },
      initialOptions: 'CRUD',
      integrationoauth2: {
        authorize: 'POST'
      },
      integrations: {
        _: 'CRUD',
        functions: {
          activateIntegration: 'POST',
          fetchBusinessCentralCompanies: 'POST',
          fetchCompanyRoleUsers: 'GET',
          fetchEconomicJournals: 'POST',
          fetchPAXMLPayTypeCodes: 'GET',
          fetchTripletexVoucherTypes: 'GET',
          fetchUnicontaCompanies: 'POST',
          getIntegrationPrice: 'GET',
          hasEnabledIntegration: 'GET',
          jira: {
            fetchWorklogs: 'POST'
          }
        },
        notes: 'GET'
      },
      invoiceDeliveryLogs: 'CRUD',
      invoiceLines: {
        _: 'CRUD',
        generate: {
          $filename__pdf: 'POST',
          $filename__xlsx: 'POST'
        },
        getReportWithPaging: 'GET'
      },
      invoicePriceDefinitionTotals: 'CRUD',
      invoiceTimeRecords: 'CRUD',
      invoices: {
        $id: {
          functions: {
            createCreditNote: 'POST',
            createForOtherCustomer: 'POST',
            createInvoiceCopy: 'POST',
            eInvoicingStatus: 'GET',
            syncTags: 'POST,PUT'
          },
          getChangeAndDeliveryLog: 'GET',
          getInvoicePreviewPdf: 'GET',
          paymentId: 'GET',
          sendForApprove: 'POST',
          statusFlags: 'PUT,PATCH'
        },
        $invoiceId: {
          functions: {
            createAndDownloadInvoiceWithPdfAttachments: 'POST',
            createPDF: 'POST',
            peppolPreview: 'GET',
            refreshInvoiceAndPDF: 'POST',
            send: 'POST'
          }
        },
        _: 'CRUD',
        createCommonPdfForInvoices: 'POST',
        createPaymentReminderPdfForInvoices: 'POST',
        drafts: {
          $invoiceId: {
            functions: {
              finalize: 'POST'
            }
          },
          _: 'POST',
          functions: {
            finalizeBatch: 'POST',
            finalizeBatchAndGetSendDtos: 'POST'
          }
        },
        editSendingState: 'POST',
        editTransferState: 'POST',
        exportToFile: 'GET',
        fixInvoicesWithSmallOutstandingAmount: 'POST',
        functions: {
          adminCreatePDFs: 'POST',
          createPDFs: 'POST',
          hasStartDatePriorPogLockDate: 'GET',
          isFirstInvoiceSentToCustomer: 'GET',
          moveToProjectExtensions: 'POST',
          sendBatch: 'POST'
        },
        generate: {
          $filename__pdf: 'POST',
          $filename__xlsx: 'POST'
        },
        generateExcelTemplate: 'GET',
        getOverdueInvoicesList: 'GET',
        getReportWithPaging: 'GET',
        getSendInvoiceBatchItemDtosForInvoices: 'GET',
        getSendInvoiceDtosForPaymentRemindersForInvoices: 'GET',
        invoiceDeliveryLogs: {
          $id: 'DELETE'
        },
        outstandingSumForSentInvoicesInCompanyCurrency: 'GET',
        reversePOGInvoices: 'POST',
        sendPaymentReminderEmailsForInvoices: 'POST',
        setAllInvoiceFromToNumberAsPaid: 'POST',
        setCreatedDateToNow: 'POST',
        setInvoiceHistoryForPriceModel: 'POST',
        updateFromExcel: 'POST',
        updateLockDate: 'POST',
        updatePostponeReminderUntilDate: 'POST'
      },
      invoicingCurrencySetups: 'CRUD',
      invoicingPreferences: {
        _: 'CRUD',
        additionalCustomer: {
          $id: 'GET,PUT'
        },
        company: 'GET,PUT',
        customer: {
          $id: 'GET,PUT'
        },
        department: {
          $id: 'GET,PUT'
        },
        priceDefinition: {
          $id: 'GET,PUT'
        },
        project: {
          $id: 'GET,PUT'
        },
        projectExtension: {
          $id: 'GET,PUT'
        }
      },
      ipaas: {
        _: 'CRUD',
        activities: {
          $id: 'GET',
          _: 'GET'
        },
        customers: {
          $id: {
            _: 'GET,PUT',
            contacts: {
              $contactId: 'PUT',
              _: 'GET,POST'
            },
            electronicInvoiceAddresses: {
              $customerId: 'PUT',
              _: 'GET,POST'
            }
          },
          _: 'GET,POST'
        },
        expenses: {
          $id: 'GET,PATCH',
          _: 'GET,POST'
        },
        files: {
          $id: {
            _: 'GET',
            content: 'GET'
          },
          _: 'GET,POST'
        },
        financialAccounts: {
          $id: 'GET',
          _: 'GET'
        },
        invoices: {
          $id: 'GET,PATCH,PUT',
          _: 'GET'
        },
        payments: {
          $id: 'GET',
          _: 'GET,POST'
        },
        projects: {
          $id: 'GET',
          _: 'GET'
        },
        tags: {
          $id: 'GET',
          _: 'GET'
        },
        userAccounts: {
          $id: 'GET,PATCH,PUT',
          _: 'GET,POST'
        }
      },
      licenseCountChanges: 'CRUD',
      links: 'GET',
      list: 'GET',
      listAll: 'GET',
      logs: {
        _: 'CRUD',
        test: {
          insert: 'GET'
        }
      },
      mileageClaim: 'POST',
      milestones: 'CRUD',
      mobile: {
        _: 'CRUD',
        batchFiles: 'POST',
        batchImages: 'POST',
        images: 'POST'
      },
      momentIntegrations: 'CRUD',
      momentLicenseInvoices: {
        _: 'CRUD',
        getUnpaid: 'GET'
      },
      momentPlan: 'GET',
      momentPlans: 'GET',
      moneyTransactions: {
        _: 'CRUD',
        functions: {
          splitTransaction: 'POST'
        },
        generate: {
          $filename__pdf: 'POST',
          $filename__xlsx: 'POST'
        },
        getReportWithPaging: 'GET'
      },
      nationalHolidays: {
        _: 'CRUD',
        batch: {
          insert: 'POST'
        },
        latest: 'GET',
        load: 'GET',
        search: {
          findByDate: 'GET'
        },
        update: 'POST'
      },
      nonconformities: {
        $id: {
          getFollowupTaskCounts: 'GET'
        },
        _: 'CRUD',
        functions: {
          copyToProject: 'POST'
        },
        generate: {
          $filename__pdf: 'POST',
          $filename__xlsx: 'POST'
        },
        getReportWithPaging: 'GET'
      },
      nonconformityInProjectParticipantCompanies: 'CRUD',
      notes: {
        _: 'CRUD',
        changeLogs: 'GET',
        qualitySettings: 'GET'
      },
      notificationSubscriptions: 'CRUD',
      notifications: {
        _: 'CRUD',
        functions: {
          readAll: 'POST'
        }
      },
      offerExpenseLines: 'CRUD',
      offerHourlyRates: 'CRUD',
      offerProductSaleLines: 'CRUD',
      offerProjectExtensionLines: 'CRUD',
      offerRecipients: {
        _: 'CRUD',
        removeOfferRecipient: 'DELETE'
      },
      offerTaskLinePriceEntries: 'CRUD',
      offerTaskLines: 'CRUD',
      offers: {
        $id: {
          addProjectMembershipRoles: 'POST',
          changelog: {
            $changelogId: 'GET'
          },
          connectToProject: {
            $projectId: 'POST'
          },
          connectedProjectHasDirectlyAddedEntities: 'GET',
          copyToNew: 'PUT,PATCH',
          functions: {
            closeConnectedEntities: 'POST',
            removeConnectedEntities: 'POST',
            sendToRecipient: 'POST'
          },
          notes: 'GET',
          updateProject: 'PUT'
        },
        _: 'CRUD',
        generate: {
          $filename__pdf: 'POST',
          $filename__xlsx: 'POST'
        },
        getReportWithPaging: 'GET',
        listOfInvalid: 'GET',
        nextOfferNumber: 'GET',
        updateHourlyRates: 'PUT',
        updateSubLinesSortOrders: 'PUT'
      },
      offers$id: {
        preview: 'GET'
      },
      overtimeAdjustments: {
        _: 'CRUD',
        functions: {
          transferAdjustments: 'POST'
        },
        recreate: 'POST'
      },
      overtimeCategories: 'CRUD',
      partialDays: 'CRUD',
      paymentCards: {
        _: 'CRUD',
        getCardOwners: 'GET'
      },
      plannedPayments: {
        _: 'CRUD',
        generate: {
          $filename__pdf: 'POST',
          $filename__xlsx: 'POST'
        },
        getReportWithPaging: 'GET'
      },
      preferences: {
        $scope: {
          $id: {
            $key: 'PATCH'
          },
          _: 'GET,PATCH,PUT'
        },
        _: 'CRUD',
        mobilePreferences: 'DELETE,POST'
      },
      priceDefinitionCustomerPercentages: 'CRUD',
      priceDefinitionDefaultHourlyRates: 'CRUD',
      priceDefinitionInvoicedRecords: 'CRUD',
      priceDefinitions: {
        _: 'CRUD',
        plannedPaymentsAsExcel: 'GET',
        updateExtensionsAndRemovePriceDefinitiion: {
          $priceDefinitionId: 'DELETE'
        },
        updateRemainingToSpecify: 'PATCH',
        withHourlyRates: {
          $priceDefinitionId: 'DELETE,GET,PUT',
          _: 'POST'
        },
        withSurcharges: 'PATCH'
      },
      productGroups: 'CRUD',
      productPriceLists: 'CRUD',
      productSales: {
        _: 'CRUD',
        copyProductSales: 'POST',
        generate: {
          $filename__pdf: 'POST',
          $filename__xlsx: 'POST'
        },
        getBatchCreateProductSalesTemplateExcel: 'GET',
        getReportWithPaging: 'GET',
        nextProductSaleNumber: 'GET',
        parseAndSaveProductSalesFromExcel: 'POST',
        parseProductSalesFromExcel: 'GET'
      },
      products: {
        $id: {
          notes: 'GET'
        },
        _: 'CRUD',
        exportToFile: 'GET',
        functions: {
          getMomentPlanPrices: 'GET'
        },
        generateExcelTemplate: 'GET',
        updateFromExcel: 'POST'
      },
      projectBudgetSnapshots: 'CRUD',
      projectExpenseCategoryBudgets: 'CRUD',
      projectExtensionMemberships: 'CRUD',
      projectExtensionPayments: 'CRUD',
      projectExtensionReservations: 'CRUD',
      projectExtensionRevisions: 'CRUD',
      projectExtensionTemplates: 'CRUD',
      projectExtensions: {
        $projectExtensionId: {
          isAbleToMove: 'GET'
        },
        _: 'CRUD',
        functions: {
          deleteByName: 'POST',
          moveSharepointFiles: {
            $id: 'PUT'
          },
          moveToProject: 'POST',
          syncMembershipActivities: 'POST'
        },
        generate: {
          $filename__pdf: 'POST',
          $filename__xlsx: 'POST'
        },
        getReportWithPaging: 'GET',
        overview: 'GET'
      },
      projectIncomingEmails: 'CRUD',
      projectInvoiceEmailSubscriptions: 'CRUD',
      projectMembershipHourlyRates: {
        _: 'CRUD',
        functions: {
          addHourlyRateForOldUserIdAndProject: 'POST'
        }
      },
      projectMembershipInternalHourlyRates: 'CRUD',
      projectMembershipRoleHourlyRates: 'CRUD',
      projectMembershipRoles: {
        _: 'CRUD',
        countByState: 'GET'
      },
      projectMemberships: {
        _: 'CRUD',
        functions: {
          batchProjectMembership: 'POST',
          setProjectMembershipsWithRoleAsProjectOwners: 'POST'
        },
        selfJoinProject: 'POST'
      },
      projectOfferResources: 'CRUD',
      projectParticipantCompanies: {
        $id: {
          inviteForReview: 'POST'
        },
        _: 'CRUD',
        generate: {
          $filename__pdf: 'POST',
          $filename__xlsx: 'POST'
        },
        getReportWithPaging: 'GET',
        projectParticipantsInProjectOverview: {
          $projectId: 'GET'
        }
      },
      projectParticipantCompanyCategories: 'CRUD',
      projectParticipantCompanyContacts: 'CRUD',
      projectResourceReservations: {
        _: 'CRUD',
        batchUpdateReservations: {
          _: 'POST',
          include: {
            $includes: 'POST'
          }
        },
        byPeriod: 'POST',
        byWeek: {
          _: 'GET',
          batch: 'POST'
        },
        forecastSum: 'GET',
        functions: {
          createFromTaskReservation: 'POST',
          movePlanHour: 'POST',
          notifyAboutOverworking: 'POST',
          reallocatePlanHour: 'POST'
        },
        latestWithColor: 'GET',
        monthBalance: {
          _: 'GET',
          report: 'GET'
        },
        moveHoursAndMilestones: 'POST',
        projectMembershipTime: 'GET',
        reservationDetails: 'GET',
        statisticForDay: 'GET',
        totalPlanMinutesFromDate: 'GET',
        weekBalance: 'GET'
      },
      projectRevisionWeekSums: 'CRUD',
      projectRevisions: {
        $id: {
          periodizationModel: 'GET',
          projectPlanBudgetModel: 'GET'
        },
        _: 'CRUD'
      },
      projectTemplates: {
        $id: {
          generateForProject: {
            $projectId: 'POST'
          }
        },
        _: 'CRUD',
        createQualitySystemTemplate: 'GET'
      },
      projectonline: {
        $momentProjectId: {
          _: 'GET,POST',
          functions: {
            detach: 'POST',
            syncTasks: 'POST',
            syncTimerecords: 'POST'
          }
        },
        _: 'CRUD'
      },
      projects: {
        $id: {
          approveForInvoicing: 'POST',
          budget: 'GET',
          budgetExpenses: 'GET',
          budgetMonthly: 'GET',
          budgetMonthlyToExcel: 'GET',
          competency: 'GET',
          createOffer: 'POST',
          createOfferAndLoadPdf: 'POST',
          delayInvoicing: 'POST',
          financial_results: 'GET',
          functions: {
            recalculateProfit: 'POST'
          },
          generatePDF: 'GET',
          getMaks10ProjectNodeId: 'GET',
          keyNumbers: 'GET',
          metadata: 'GET',
          nextProjectExtensionNumber: 'GET',
          notes: 'GET',
          overview: 'GET',
          periodization: 'GET',
          projectMetadataForInlineEditing: 'GET',
          projectPlanBudget: 'GET',
          selfJoin: 'GET,PUT',
          setAllToInvoiced: 'POST',
          setAllToNotBillable: 'POST',
          singleToBeInvoiced: 'GET',
          synchronizeResources: 'POST',
          team: 'GET',
          toBeInvoiced: 'GET'
        },
        _: 'CRUD',
        allProjectPermissionsForUserAccount: 'GET',
        budgetMonthly: 'GET',
        budgetMonthlyToExcel: 'GET',
        budgetOverview: 'GET',
        changeProjectNumberSeriesToBeginWith: 'POST',
        cloneProject: 'POST',
        closeProjectsWithoutActivityFromDate: 'POST',
        convertProjectFromDestinationToSource: 'POST',
        convertTimeRecordTagsToProjectActivities: 'POST',
        editTransferState: 'POST',
        exportToBeInvoicedToExcel: 'POST',
        exportToBeInvoicedToExcelColumns: 'GET',
        exportToFile: 'GET',
        functions: {
          deleteAllTimeRecords: 'POST',
          findLastProjectsOnTimeRecords: 'GET',
          recalculateProfit: 'POST',
          requiresStartupDate: 'GET'
        },
        gantt: 'GET',
        generate: {
          $filename__pdf: 'POST',
          $filename__xlsx: 'POST'
        },
        generateExcelTemplate: 'GET',
        getReportWithPaging: 'GET',
        importFromOtherProject: 'POST',
        migrateProjectsToActivities: 'POST',
        nextProjectNumber: 'GET',
        overview: 'GET',
        projectRegisteredHoursReport: {
          _: 'GET',
          generate: {
            $filename__pdf: 'POST',
            $filename__xlsx: 'POST'
          },
          getReportWithPaging: 'GET'
        },
        projectStatuses: 'GET',
        recreateSubscriptionLines: 'POST',
        search: {
          findSimpleByExactProjectNumber: 'GET',
          findSimpleByNameStartingWith: 'GET'
        },
        setCreatedDateToNow: 'POST',
        staffing: 'GET',
        synchronizeSourceProjectsAndTimeRecords: 'POST',
        toBeInvoiced: 'GET',
        updateFromExcel: 'POST'
      },
      qlik: {
        _: 'CRUD',
        activate: {
          $userAccountId: 'POST'
        },
        auth: 'GET',
        deactivate: {
          $userAccountId: 'DELETE'
        },
        demo: 'GET',
        possibleLinks: 'GET',
        possibleUsers: {
          $companyId: 'GET'
        },
        reload: 'GET,POST',
        tenant: {
          $tenantId: {
            _: 'PUT',
            attach: {
              $companyId: 'POST'
            },
            deallocate: {
              $systemUserId: 'DELETE',
              _: 'DELETE'
            },
            detach: {
              $companyId: 'DELETE'
            },
            dev: {
              connection: {
                $companyId: 'POST'
              }
            },
            reload: {
              $companyId: 'POST'
            }
          }
        },
        tenants: {
          _: 'GET,POST',
          include: {
            base: 'GET'
          }
        },
        ticket: 'GET',
        updateAndReload: {
          $companyId: 'POST'
        },
        updateTheme: 'POST',
        v2: {
          tenant: {
            $tenantId: {
              attach: {
                $companyId: 'POST'
              },
              dump: {
                $companyId: {
                  status: 'GET',
                  trigger: 'POST'
                }
              },
              reload: {
                $companyId: 'POST'
              }
            }
          }
        }
      },
      reminders: 'CRUD',
      reports: {
        $reportName: 'GET',
        $reportNameWithExtension: 'GET',
        _: 'CRUD',
        data: {
          availability: 'GET',
          reservations: 'GET'
        },
        exportCompanyLogToExcel: 'GET',
        generate: {
          hoursComparedToBudgetReport: {
            $filename__xlsx: 'GET'
          }
        },
        hoursComparedToBudget: 'GET',
        performanceReport: 'GET'
      },
      resourceReservationSuggestedSums: 'CRUD',
      revisions: 'CRUD',
      risks: {
        _: 'CRUD',
        functions: {
          copyToProject: 'POST'
        },
        generate: {
          $filename__pdf: 'POST',
          $filename__xlsx: 'POST'
        },
        getReportWithPaging: 'GET'
      },
      routineGroups: 'CRUD',
      routines: {
        $routineId: {
          assignTo: {
            tasks: 'POST'
          }
        },
        _: 'CRUD',
        functions: {
          batchTask: 'POST'
        },
        nextRoutineNumber: 'GET',
        notifyAboutChangesInRoutine: 'POST',
        sharedRoutineTemplates: 'GET'
      },
      scheduledReportJob: {
        _: 'CRUD',
        run: 'POST'
      },
      scheduledTaskSettings: {
        _: 'CRUD',
        functions: {
          pause: 'POST',
          pausePreview: 'GET',
          pauseState: 'GET',
          resume: 'POST',
          run: 'POST',
          stop: 'POST'
        },
        getCompanies: 'GET'
      },
      scheduledTaskSettingsLog: 'CRUD',
      scriveDocuments: {
        _: 'CRUD',
        functions: {
          cancel: {
            $documentId: 'PUT'
          },
          prolong: {
            $documentId: 'PUT'
          },
          remind: {
            $documentId: 'PUT'
          }
        }
      },
      search: {
        _: 'CRUD',
        flat: 'GET',
        grouped: 'GET'
      },
      sendMomentSalesEmail: 'POST',
      settings: {
        claims: {
          _: 'CRUD',
          functions: {
            resetCompanySetup: 'POST'
          },
          templates: {
            entries: {
              $settingsId: 'PUT',
              _: 'GET',
              configurationFileFormat: 'GET',
              jsonEditor: 'GET'
            }
          }
        }
      },
      sharedProjectLinks: 'CRUD',
      sharedTimeRecordLinks: 'CRUD',
      signRequest: 'CRUD',
      subscriptionLines: 'CRUD',
      subscriptionProducts: 'CRUD',
      subscriptionQuantityChanges: 'CRUD',
      subscriptions: {
        _: 'CRUD',
        editLinesBillableState: 'POST',
        editProductPrices: 'POST',
        frequencyMonthsCounts: 'GET',
        generate: {
          $filename__pdf: 'POST',
          $filename__xlsx: 'POST'
        },
        getReportWithPaging: 'GET'
      },
      tagGroupRules: 'CRUD',
      tagGroups: {
        _: 'CRUD',
        createQualitySystemTags: 'GET'
      },
      tags: {
        $id: {
          functions: {
            entityCount: 'GET'
          }
        },
        _: 'CRUD'
      },
      tagsInCloudFiles: 'CRUD',
      tagsInCustomers: 'CRUD',
      tagsInInvoices: 'CRUD',
      tagsInMilestones: 'CRUD',
      tagsInNonconformities: 'CRUD',
      tagsInProjectExtensionTemplates: 'CRUD',
      tagsInProjectExtensions: 'CRUD',
      tagsInProjectMemberships: 'CRUD',
      tagsInProjectTemplates: 'CRUD',
      tagsInProjects: 'CRUD',
      tagsInTasks: 'CRUD',
      tagsInTimeRecords: 'CRUD',
      tagsInUserAccounts: 'CRUD',
      taskMemberships: {
        _: 'CRUD',
        functions: {
          setTaskReservations: {
            $taskMembershipId: 'POST'
          }
        }
      },
      taskRequestedByCustomer: 'CRUD',
      taskReservations: {
        _: 'CRUD',
        availableDates: 'GET',
        deleteFromDate: 'POST',
        overview: 'GET'
      },
      taskSchedules: 'CRUD',
      taskTemplates: 'CRUD',
      tasks: {
        _: 'CRUD',
        functions: {
          createFromTemplate: 'PUT',
          fixRecurringTasks: 'GET',
          openCloseTasksByTag: 'POST',
          taskBoard: {
            dayTermGroups: 'GET'
          },
          taskPeriods: 'GET',
          taskStatusOverview: 'GET'
        },
        generate: {
          $filename__pdf: 'POST',
          $filename__xlsx: 'POST'
        },
        getReportWithPaging: 'GET',
        merge: 'POST',
        overview: 'GET',
        taskBoard: 'GET',
        updateSortOrders: 'POST'
      },
      tempsubscriptions: {
        _: 'CRUD',
        createTorpedoAdmSubscriptionInvoice: 'POST'
      },
      test: {
        _: 'CRUD',
        throwErrorPlease: 'GET'
      },
      timeRecordAdjustments: {
        _: 'CRUD',
        batchRecreate: 'POST',
        functions: {
          transferAdjustments: 'POST'
        },
        recreate: 'POST'
      },
      timeRecordAlerts: 'CRUD',
      timeRecords: {
        _: 'CRUD',
        absenceStatisticsAsExcel: 'GET',
        absencesStatisticsOverview: 'GET',
        educationFundAmountAccrueStatisticsOverview: 'GET',
        educationFundStatisticsAsExcel: 'GET',
        exportToFile: 'GET',
        functions: {
          addProjectsToTimesheet: 'POST',
          connectTimeRecordsToInvoices: 'POST',
          createTimeRecordsAsBatch: 'POST',
          moveAllTimeRecordsFromProjectToProjectExtension: 'POST',
          setTimeRecordsInvoicedState: 'POST',
          setTimeRecordsSalaryAndSharedCost: 'POST',
          syncSharedMemberships: 'POST'
        },
        generate: {
          $filename__pdf: 'POST',
          $filename__xlsx: 'POST'
        },
        generateExcelTemplate: 'GET',
        generateOvertimes: {
          $filename__pdf: 'POST',
          $filename__xlsx: 'POST'
        },
        getOvertimesOverview: 'GET',
        getOvertimesOverviewWithPaging: 'GET',
        getReportWithPaging: 'GET',
        hoursSaldoStatistics: 'GET',
        hoursSaldoStatisticsAsExcel: 'GET',
        hoursSaldoStatisticsByUserTagGroup: 'GET',
        hoursSaldoStatisticsEndDates: 'GET',
        hoursSaldoStatisticsOverview: 'GET',
        updateFromExcel: 'POST'
      },
      timers: {
        $id: {
          $action: 'PUT'
        },
        _: 'CRUD',
        canStart: 'GET',
        function: {
          count: 'GET'
        },
        lastActive: 'GET'
      },
      timesheetNotes: 'CRUD',
      userAccountFavoriteCloudFiles: 'CRUD',
      userAccountFavoriteProjects: 'CRUD',
      userAccountHourlyRates: {
        _: 'CRUD',
        getUpdateUserAccountHourlyRatesTemplateExcel: 'GET',
        mergedTotalSalaryAndSharedCost: 'GET',
        updateUserAccountCostForAllTimeRecords: 'POST',
        updateUserAccountHourlyRatesByExcel: 'POST'
      },
      userAccountInvitations: 'GET',
      userAccountSchedules: {
        _: 'CRUD',
        overview: 'GET'
      },
      userAccounts: {
        $id: {
          functions: {
            borrowPermissions: 'GET'
          },
          generatePDF: 'GET',
          moveDataToOtherUserAndDisable: 'POST',
          moveUserProjectsToOtherCompanyInGroup: 'POST',
          moveUserToOtherCompanyInGroup: 'POST',
          quitCoworker: 'POST',
          resetManagers: 'POST',
          setReservationComment: 'POST',
          setTimeLockDate: 'POST'
        },
        $userAccountId: {
          balanceStatistics: 'GET',
          claims: {
            $claimId: {
              _: 'DELETE,GET,PUT',
              approve: 'POST',
              entries: {
                $claimEntryId: {
                  _: 'DELETE,GET,PUT',
                  cloudFiles: {
                    $cloudFileId: 'DELETE',
                    _: 'POST'
                  }
                },
                _: 'POST'
              },
              functions: {
                approve: 'POST',
                refund: 'POST',
                reject: 'POST',
                undoRefund: 'POST'
              },
              include: {
                $includes: 'GET'
              },
              refund: 'POST',
              reject: 'POST',
              undoRefund: 'POST'
            },
            _: 'GET,POST'
          },
          dashboardStatistics: 'GET',
          existsAsManagerOrApprover: 'GET',
          existsInTravelAndExpenseApprovers: 'GET',
          groupedProjects: 'GET',
          hrOverview: 'GET',
          mileageClaim: 'POST',
          password: 'POST',
          permissions: 'GET',
          projectsInfo: 'GET',
          projectsOverviewStatistics: 'GET',
          roles: 'GET,POST',
          scheduleStatistics: 'GET',
          timeRecordsStatistics: 'GET',
          topProjects: 'GET'
        },
        _: 'CRUD',
        authenticationTokens: 'GET',
        availableTimeOverview: 'GET',
        exportToFile: 'GET',
        generate: {
          $filename__pdf: 'POST',
          $filename__xlsx: 'POST'
        },
        generateExcelTemplate: 'GET',
        getReportWithPaging: 'GET',
        me: {
          functions: {
            grantSupportAccess: 'POST'
          },
          toApproveInfo: 'GET'
        },
        overview: 'GET',
        projectMembers: 'GET',
        sendWelcomeAndSetNewPasswordEmail: 'POST',
        setTimeLockDateForAll: 'POST',
        setTimeLockDateForArray: 'POST',
        timeRecordsStatuses: 'GET',
        updateFromExcel: 'POST',
        userAccountInvitations: 'POST'
      },
      utils: {
        reports: {
          _: 'CRUD',
          generate: {
            $filename__pdf: 'POST',
            $filename__xlsx: 'POST'
          },
          json: {
            _: 'CRUD',
            generate: {
              $filename__pdf: 'POST',
              $filename__xlsx: 'POST'
            }
          }
        }
      },
      webhookEvents: 'CRUD',
      webhooks: {
        jira: {
          $secretKey: 'POST',
          _: 'CRUD'
        }
      },
      workingDays: 'CRUD'
    },
    $companyemployeesEducationAbsenceType: 'CRUD',
    functions: {
      _: 'CRUD',
      mainCompanyHasEnabledSsoIntegration: 'GET',
      myMainCompanyCode: 'GET'
    }
  },
  countryCodes: 'GET',
  currencies: {
    _: 'CRUD',
    currencyCodes: 'GET'
  },
  currencyRates: {
    _: 'CRUD',
    functions: {
      fetchAndUpdateCurrencyRates: 'POST'
    },
    production_proxy: 'GET',
    statistics: 'GET'
  },
  customerRegistryData: {
    _: 'CRUD',
    getAllAddresses: 'GET',
    getByOrganizationNumber: {
      $organizationNumber: 'GET'
    },
    getByOrganizationalFormCode: {
      $organizationalFormCode: 'GET'
    },
    getByTradeCode: {
      $tradeCode: 'GET'
    }
  },
  errors: {
    $statusCode: 'GET',
    default: 'GET'
  },
  external: {
    cvr: {
      _: 'CRUD',
      companySearch: {
        simulateBrreg: 'GET'
      }
    },
    eniro: {
      _: 'CRUD',
      companySearch: {
        _: 'GET',
        simulateBrreg: 'GET'
      }
    }
  },
  federatedIdentity: 'CRUD',
  feedback: 'CRUD',
  global: {
    e_invoicing: {
      _: 'CRUD',
      lookup: 'GET',
      schemes: 'GET'
    },
    latestRates: 'CRUD',
    projects: {
      $projectNumber: {
        maks10: {
          info: 'GET'
        }
      },
      _: 'CRUD'
    },
    webhooks: {
      _: 'CRUD',
      test: 'GET'
    }
  },
  integrationoauth2: {
    codeCallback: 'GET'
  },
  invoiceHistory: {
    _: 'CRUD',
    functions: {
      recreateInvoiceHistory: 'POST'
    }
  },
  invoiceReexport: 'CRUD',
  messages: {
    _: 'CRUD',
    listen: 'GET',
    send: 'GET'
  },
  mobile: {
    _: 'CRUD',
    images: 'POST'
  },
  moneyTransactionsImport: {
    _: 'CRUD',
    functions: {
      checkMissingMoneyTransactions: 'GET',
      fetchAndRegisterMoneyTransactionsFromNets: 'POST'
    }
  },
  public: {
    cspViolationReports: 'CRUD',
    files: {
      $publicId: 'GET'
    },
    heartbeat: 'GET',
    inCluster: 'GET',
    initialOptions: 'CRUD',
    offers: {
      $id: {
        accept: 'POST',
        decline: 'POST'
      },
      $publicId: {
        _: 'GET',
        attachments: {
          $cloudFileId: 'GET'
        }
      },
      $publicId__html: 'GET',
      $publicId__pdf: 'GET',
      $publicId_ret__pdf: 'GET',
      _: 'CRUD'
    },
    reviews: {
      $publicId: {
        _: 'GET,PUT',
        senderLogo: 'GET'
      },
      _: 'CRUD'
    },
    supportAccess: {
      _: 'CRUD',
      grant: 'POST'
    }
  },
  resetpassword: 'POST',
  shared: {
    checklists: 'CRUD'
  },
  signup: {
    _: 'CRUD,GET',
    admin: {
      createSystemUser: 'POST'
    },
    confirm_email: {
      $code: 'GET'
    },
    createCompany: 'POST',
    createSystemUser: 'POST',
    gatherIntel: 'GET',
    initialOptions: 'GET',
    registerEmail: 'POST',
    suggestCompanyCode: 'GET'
  },
  translations: {
    _: 'CRUD',
    publicClient__js: 'GET'
  },
  userAccountInvitations: {
    _: 'CRUD',
    from: 'GET',
    to: 'GET'
  },
  users: {
    _: 'CRUD',
    functions: {
      admin: {
        askForSupportAccess: 'POST',
        globalSearch: {
          _: 'GET',
          include: {
            $includes: 'GET'
          }
        },
        globalSearchWithUserAccounts: 'GET,POST',
        supportAccessStatuses: 'GET',
        verify: 'POST'
      },
      exists: 'GET',
      removeByEmailWithoutUserAccount: 'POST'
    },
    me: {
      _: 'GET',
      chatToken: 'GET',
      functions: {
        createApiKey: 'GET,POST'
      },
      lastNewsPopupDismissedAt: 'POST',
      readNewsEntries: 'POST',
      subscribeToNewsletter: 'POST',
      system: 'GET'
    }
  },
  webhooks: {
    economic: 'CRUD',
    mandrill: 'CRUD',
    scrive: 'CRUD',
    tripletex: 'CRUD',
    younium: 'CRUD'
  }
} as const);

const cApi = Api.companies.$company; // short alias for company api

export { Api, cApi };
